import { useState, useEffect, forwardRef } from "react";
import ReactSelect from 'react-select';
import Fetch from '../../../../../util/core/Fetch';

const Select = forwardRef((props, ref) => {
  const [value, updateValue] = useState(props.value);
  const [options, updateOptions] = useState(props.options || []);
  const [readOnly, setReadOnly] = useState(false);
  const [sort, setSort] = useState(props.sort === undefined ? 'ASC' : props.sort);
  let className = '';
  let customStyle = {};

  useEffect(() => {
    const loadOptions = async () => {
      let tempOptions = [];

      if (props.optionsEndpoint && props.optionsEndpoint.endpoint) {
        const url = props.optionsEndpoint.endpoint;
        const keyLabel = props.optionsEndpoint.label;
        const keyValue = props.optionsEndpoint.value;
        const params = props.optionsEndpoint.params || {};
        const rows = await Fetch.post(url, params);

        tempOptions = rows.map(item => ({
          value: item[keyValue],
          label: item[keyLabel],
          group: item.group,
        }));

        if (sort) {
          tempOptions.sort((a, b) => {
            const labelA = a.label || '';
            const labelB = b.label || '';
            return labelA.toLowerCase().localeCompare(labelB.toLowerCase());
          });

          if (sort === 'DESC') {
            tempOptions.reverse();
          }
        }

        const groupedTempOptions = tempOptions.reduce((acc, curr) => {
          const group = curr.group || 'Other';
          if (!acc[group]) {
            acc[group] = [];
          }
          acc[group].push(curr);
          return acc;
        }, {});

        const groupedOptions = Object.keys(groupedTempOptions).map(group => ({
          label: group,
          options: groupedTempOptions[group],
        }));

        updateOptions(groupedOptions);
      } else {
        tempOptions = props.options;
        updateOptions(tempOptions);
      }

      let initialValue = tempOptions.find(opt => opt.value === props.value.value);
      if (tempOptions.length === 1 && props.canAutoFill && props.required) {
        initialValue = tempOptions[0];
        setReadOnly(true);
      }

      function findObjectById(id) {
        for (const group of options) {
          for (const option of group.options) {
            if (option.value === id) {
              return option;
            }
          }
        }
        return null;
      }

      const selectedValue = findObjectById(props.value)

      updateValue(selectedValue);
    };

    loadOptions();
  }, [props.value, props.optionsEndpoint, sort, props.options]);

  const handleChange = (selectedOption) => {
    const target = {
      name: props.name,
      type: 'select',
      ...selectedOption,
    };
    updateValue(selectedOption);
    props.onChange({ target });
  };

  if (props.error) {
    className = "is-invalid";
    customStyle = { border: '1px solid #dc3545' };
  }

  return (
    <div ref={ref}>
      <div style={customStyle}>
        <ReactSelect
          styles={{
            menu: (baseStyles) => ({
              ...baseStyles,
              zIndex: 100,
            }),
            ...props.styles,
          }}
          autoFocus={props.autoFocus}
          isClearable={props.isClearable !== false}
          name={props.name}
          placeholder={props.placeholder || 'Selecione'}
          options={options}
          onChange={handleChange}
          value={value}
          isDisabled={props.disabled}
          menuIsOpen={readOnly ? false : undefined}
        />
      </div>
      {props.error && (
        <span className="error invalid-feedback" style={{ display: 'inline' }}>
          {props.error}
        </span>
      )}
    </div>
  );
});

export default Select;
